import { connectUtil, PropsFromRedux } from 'base/src/utils/reduxUtil';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { CampanhaParameters } from '../../infra/routes/campanhaRoutes';
import { useEffect } from 'react';
import PagedAprovar from './components/pagedAprovar/pagedAprovar';
import { GetAuthRoute } from 'domain/types/sistema/sistemaList';
import { Redirect } from 'base/src/utils/routeUtil';
import { GetCarteiraUsuario } from 'domain/store/_carteira/carteiraBase/actions/carteiraBaseAction';
import { ResetResgatesCheckout } from 'domain/store/_carteira/campanhaPedidoResgate/actions/campanhaPedidoResgateAction';
import { RootStateCampanha } from '../../store/campanhaReducer';
import ViewContainer from '../viewContainer/viewContainer';
import { Button } from 'base/src/components/Button';
import * as S from './pagarPedidoStyle';
import { PageBanner } from 'base/src/components/PageBanner';
import { CarteiraValorFallback } from 'domain/components/_carteira';
import { Tabs, TabsContent } from 'base/src/components/Tabs';
import ExtratoTab from './components/ExtratoTab';

const connector = connectUtil(
  (state: RootStateCampanha) => ({
    usuarioSistemaPerfil: state.UsuarioSistemaPerfilReducer.usuarioSistemaPerfil,
    TaxaPagamento: state.CarteiraBaseReducer.CarteiraBase.TaxaPagamento,
    Pagar: state.CampanhaPedidoResgateReducer.formData,
    CampanhaPedidoResgate: state.CampanhaPedidoResgateReducer.CampanhaPedidoResgateByCampanha,
  }),
  { GetCarteiraUsuario, ResetResgatesCheckout }
);

export interface PagarPedidoProps extends PropsFromRedux<typeof connector> { }

function PagarPedido(props: PagarPedidoProps) {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const campanhaId = searchParams.get(CampanhaParameters.campanhaId);

  useEffect(() => {
    props.ResetResgatesCheckout();
  }, []);

  useEffect(() => {
    props.GetCarteiraUsuario(() => { Redirect(GetAuthRoute()) });
  }, []);

  function handleNavigateToGerarLote() {
    navigate(`/gerarLote?${CampanhaParameters.campanhaId}=${campanhaId}`);
  }

  return (
    <ViewContainer>
      <S.Container>
        <S.Header style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 16 }}>
          <PageBanner showGoBack={true} title='Gerenciar Lotes de Pagamento' subtile='Aprove e gerencie lotes de pagamentos em massa' />
          <CarteiraValorFallback />
        </S.Header>

        <S.Content>
          {campanhaId && (
            <Tabs
              items={[
                { value: 'lotes', label: 'Lotes' },
                { value: 'extrato', label: 'Extrato' },
              ]}
              defaultValue="lotes"
            >
              <TabsContent value="lotes">
                <PagedAprovar
                  openModalLote={
                    <Button size='md' onClick={handleNavigateToGerarLote}>
                      Novo Lote
                    </Button>
                  }
                  take={5}
                  campanhaId={Number(campanhaId)}
                />
              </TabsContent>
              <TabsContent value="extrato">
                <ExtratoTab />
              </TabsContent>
            </Tabs>
          )}
        </S.Content>
      </S.Container>
    </ViewContainer>
  );
}

export default connector(PagarPedido);
